import { ref, onBeforeUnmount } from '@vue/composition-api'
import _ from 'lodash'
import store from '@/store'
import i18n from '@/libs/i18n'
import { cloneNested, parseRequestError } from '@/helpers/helpers'

export default () => {
  const loading = ref(false)
  const config = ref({
    multiTeacher: false,
    newCustomerDefaults: {
      paymentDeadline: null,
      settlementsTime: null,
      canCancelReservations: false,
      freeCancellationMinHours: null,
      canMakeOnlineReservations: false,
    },
  })

  const timeouts = {}

  const fetchConfig = () => {
    loading.value = true
    store.dispatch('organizationConfig/fetchOrganizationConfig')
      .then(res => {
        config.value = cloneNested(res.data)
      })
      .catch(err => parseRequestError(err))
      .finally(() => { loading.value = false })
  }

  fetchConfig()

  const saveValue = (path, value, immediate = false, clearable = false) => {
    if (!clearable && (value === null || value === '')) {
      return
    }

    _.set(config.value, path, value)
    if (immediate) {
      store.dispatch('organizationConfig/patchOrganizationConfig', { path, value })
        .catch(parseRequestError)
    } else {
      clearTimeout(timeouts[path])
      timeouts[path] = setTimeout(() => {
        store.dispatch('organizationConfig/patchOrganizationConfig', { path, value })
          .catch(parseRequestError)
      }, 2500)
    }
  }

  onBeforeUnmount(() => {
    Object.keys(timeouts).forEach(path => {
      clearTimeout(timeouts[path])
      store.dispatch('organizationConfig/patchOrganizationConfig', {
        path,
        value: _.get(config.value, path),
      })
        .catch(parseRequestError)
    })

    setTimeout(() => {
      store.dispatch('auth/fetchUserInfo').then(() => {
        store.dispatch('customer/resetCustomer')
      })
    }, 2500)
  })

  const settlementTimeOptions = [
    { id: 'AtTheEndOfMonth', label: i18n.t('customers.form.billing-details.settlement-time-options.at-the-end-of-month') },
    { id: 'AtTheBeginningOfMonth', label: i18n.t('customers.form.billing-details.settlement-time-options.at-the-beginning-of-month') },
    { id: 'AfterEveryMeeting', label: i18n.t('customers.form.billing-details.settlement-time-options.after-every-meeting') },
    { id: 'InAdvanceForAllScheduledMeetings', label: i18n.t('customers.form.billing-details.settlement-time-options.in-advance-for-all-scheduled-meetings') },
  ]

  return {
    loading,
    config,
    settlementTimeOptions,
    saveValue,
  }
}
